import { Box, Text } from '@domain-group/suit-theme'

import type { AttachmentTag } from '@domain-group/realhub-backend-api-types'

import styles from './styles.module.scss'

export const TAG_HEIGHT = 16
export const TAG_WIDTH = 16

type TagProps = {
  tag: AttachmentTag,
}

const Tag = (props: TagProps) => {
  // @ts-expect-error TS2339
  const { index, tag: { resolved, x, y } } = props

  return (
    <Box
      alignItems="center"
      backgroundColor={resolved ? 'green' : 'blue'}
      borderRadius="100%"
      className={styles.root}
      color="white"
      fontWeight="bold"
      height={`${TAG_HEIGHT}px`}
      justifyContent="center"
      left={`${x - (TAG_WIDTH / 2)}px`}
      position="absolute"
      top={`${y - (TAG_HEIGHT / 2)}px`}
      width={`${TAG_WIDTH}px`}
    >
      <Text color="white" fontSize="xxsmall" fontWeight="bold">
        {index + 1}
      </Text>
    </Box>
  )
}

export default Tag
